import ContactFormPro from "@/components/feature/ContactFormPro";

export default function ContactForm() {
  return <ContactFormPro variant="compact" formId="avis-form" useVille />;
}